import React, { useEffect } from 'react'
import { const_var } from '../../redux/reducers/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedTabstate, setZipCodeVal } from '../../action';
import { salesLoginBtnClick, setDefaultValuesOnSalesLoginBtnClick } from '../../redux/reducers/utils';

const  NonLogedin = () =>  {  
    const dispatch = useDispatch();
    let checkactivelogin = false;
    const state = useSelector((state) => state.reducer);


    const salesLogin=()=>{
      dispatch(setZipCodeVal('', "statemanufacturechangepage"))
      setDefaultValuesOnSalesLoginBtnClick()
      dispatch(getSelectedTabstate("loginstyletab"))
   }

    useEffect(()=>{
        if (localStorage.getItem('userData') != undefined) {
            checkactivelogin = true
          }
          else {
            checkactivelogin = false
      
          }
    },[])
    let isEditFullViewEnable = (const_var.ishideLeftNevigationBar != undefined && const_var.ishideLeftNevigationBar == true) ? true : false; 
    return (
        <>
        {
            isEditFullViewEnable == false &&
            <>
              {((const_var.loginSession == false && const_var.crmSetting.is_loggedin == true) && checkactivelogin == false && const_var.isPublicEdit != true) ?
                <a className="user-before-login" onClick={() => salesLogin()}>                    
                    {(const_var.crmSetting.parent_api_token == "Fq6Meq4bloS4c7Pqj7OuVNHfiPhWnuesTwy3KiuFNCJ2cyu3WKIGEFqc74qsprei" || const_var.crmSetting.parent_api_token == "P0pjF0vzahFWP8DTFzQulTkOFi5b2cpoeNrLSxIMXxgMRe0fpAYKRpFRLCPvC9ke") ? "Dealer Login" : "Sales Login"}
                </a>
                : ''}
            </>
          }
        </>
    )
}

export default NonLogedin